<template>
  <div class="daily-balance-tooltip i-p-6">
    <div class="tooltip-content">
      <div class="tooltip-container">
        <div class="tooltip-header">
          {{ title }}
        </div>
        <div class="tooltip-body">
          <div
            v-for="dataPoint in tooltipData.dataPoints"
            :key="dataPoint.datasetIndex"
            class="tooltip-row d-flex align-items-center"
          >
            <div class="tooltip-row-label d-flex align-items-center">
              <div class="tooltip-row-color-line">
                <hr
                  :style="{
                    borderColor: dataPoint.color,
                    borderStyle: dataPoint.lineStyle,
                  }"
                />
              </div>
              <div class="tooltip-label flex-grow-1">
                {{ dataPoint.label }}
              </div>
            </div>
            <div class="tooltip-row-value flex-grow-1">
              {{ valueToCurrency(dataPoint.value) }}
            </div>
          </div>
        </div>
        <div v-if="tooltipData.footer" class="tooltip-footer d-flex">
          <div class="tooltip-label">{{ tooltipData.footer.label }}</div>
          <div class="tooltip-value flex-grow-1">
            {{ valueToCurrency(tooltipData.footer.value) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { toCurrency } from '@/utils/toCurrency';

export default {
  name: 'DailyBalanceGraphTooltip',
  props: {
    tooltipData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    title() {
      let title = null;
      if (this.tooltipData.title) {
        title = moment.utc(this.tooltipData.title[0]).format("MMM Do, 'YY");
      }
      return title;
    },
  },
  methods: {
    valueToCurrency: toCurrency,
  },
};
</script>

<style lang="scss" scoped>
$leftColumnWidth: 70%;

.daily-balance-tooltip {
  position: absolute;
  font-size: 12px;
  text-align: left;
  color: #000;
  background-color: $color-white;
  pointer-events: none;
  transform: translate(-50%, 0);
  transition: all 0.1s ease;
  border-radius: 10px;
  box-shadow:
    0px 1px 20px 0px rgba(95, 95, 95, 0.15),
    0px 0px 0px 1px rgba(63, 63, 68, 0.05);
  width: 258px;

  .tooltip-content {
    padding: 0 4px;
  }
  .tooltip-header {
    color: $light-neutral-120;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    padding-bottom: 9px;
  }

  .tooltip-row {
    padding-bottom: 8px;

    .tooltip-row-label {
      width: $leftColumnWidth;
      .tooltip-row-color-line {
        margin-right: 10px;
        height: 2px;
        display: inline-block;

        hr {
          border-width: 2px 0 0 0;
          width: 16px;
          margin: 0;
        }
      }
      .tooltip-label {
        display: inline-block;
      }
    }

    .tooltip-row-value {
      text-align: right;
    }
  }
  .tooltip-footer {
    border-top: 1px solid $light-neutral-70;
    font-weight: 600;
    padding-top: 8px;
    padding-bottom: 0;

    div:nth-child(1) {
      padding-left: 26px; // 16px for the color line + 10px margim
      width: $leftColumnWidth;
    }

    div:nth-child(2) {
      text-align: right;
    }
  }
}
</style>
